export function parseHandoffLocation({ hash = "", search = "" } = {}) {
  if (search.includes("code=") || !hash.startsWith("#/handoff?")) return null;

  const params = new URLSearchParams(hash.slice("#/handoff?".length));
  const code = params.get("code");
  if (!code || !/^[A-Za-z0-9_-]+$/.test(code)) return null;

  const returnPath = params.get("return_path");
  return {
    code,
    returnPath:
      returnPath &&
      returnPath.startsWith("/") &&
      !returnPath.startsWith("//") &&
      !returnPath.includes("\\")
        ? returnPath
        : null,
  };
}

export function takeHandoffFromLocation({
  location = window.location,
  history = window.history,
} = {}) {
  const handoff = parseHandoffLocation(location);
  if (!handoff) return null;

  history.replaceState(
    {},
    document.title,
    `${location.pathname}${location.search}`,
  );
  return handoff;
}
